import { router } from 'expo-router';
import {
  clampBadgeCount,
  formatBadgeCountLabel,
  resolveNotificationRoute,
  type NotificationRouteLike,
} from '@/lib/notifications/notificationCore';

export { clampBadgeCount, formatBadgeCountLabel, resolveNotificationRoute };

export type PushCapabilityStatus = {
  state: 'supported' | 'unsupported' | 'unknown';
  title: string;
  detail: string;
};

export async function getExpoPushToken(): Promise<string | null> {
  return null;
}

export async function getCurrentExpoPushToken(_timeoutMS?: number): Promise<string | null> {
  return null;
}

export async function requestNotificationPermission(): Promise<'granted' | 'denied' | 'undetermined'> {
  return 'denied';
}

export async function getNotificationPermissionStatus(): Promise<'granted' | 'denied' | 'undetermined'> {
  return 'denied';
}

export async function getPushCapabilityStatus(
  _permissionStatus: 'granted' | 'denied' | 'undetermined'
): Promise<PushCapabilityStatus> {
  return {
    state: 'unsupported',
    title: 'Unavailable here',
    detail: 'Radious push alerts do not deliver in the web app.',
  };
}

export function setupAndroidChannel() {}

export function openNotificationTarget(data: NotificationRouteLike) {
  router.navigate(resolveNotificationRoute(data) as never);
}

export function handleNotificationResponse(_response: unknown) {}

export function addNotificationResponseReceivedListener(_listener: (response: unknown) => void) {
  return {
    remove() {},
  };
}

export function addPushTokenListener(_listener: () => void) {
  return {
    remove() {},
  };
}

export async function setAppIconBadgeCount(_count: number) {
  return false;
}
